<template>
  <th class="qb-sticky">
    <slot></slot>
  </th>
</template>

<script>
export default {
  name: 'qb-th',
}
</script>

<style>
</style>